import { render } from "./RoleAddHeader.vue?vue&type=template&id=ed25b19e"
import script from "./RoleAddHeader.vue?vue&type=script&lang=js"
export * from "./RoleAddHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__